module.exports = __webpack_public_path__ + "img/about_logo_06.fba8b661.png";